import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { api } from '../shared/api/client';
import { usePlatformAuthStore } from '../shared/store/platformAuthStore';

export function PlatformLoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const setSession = usePlatformAuthStore((s) => s.setSession);
  const [email, setEmail] = useState('platform@parking.saas');
  const [password, setPassword] = useState('Platform123!');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await api.platformLogin({ email, password });
      setSession({
        accessToken: data.tokens.accessToken,
        refreshToken: data.tokens.refreshToken,
        admin: data.admin,
      });
      navigate('/platform');
    } catch (err) {
      setError(err instanceof Error ? err.message : t('common.loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="d-flex align-items-center gap-2 mb-3">
          <span className="symbol symbol-primary">
            <i className="bi bi-building" />
          </span>
          <span className="fw-bold">{t('platform.brand')}</span>
        </div>
        <h1>{t('platform.brand')}</h1>
        <p className="lead">{t('platform.login.subtitle')}</p>
        <form onSubmit={onSubmit} className="d-grid gap-3">
          {error ? <div className="alert alert-danger mb-0">{error}</div> : null}
          <div>
            <label className="form-label">{t('platform.login.email')}</label>
            <input
              className="form-control"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="form-label">{t('platform.login.password')}</label>
            <input
              className="form-control"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
            {loading ? (
              <span className="spinner-border spinner-border-sm" role="status" />
            ) : (
              t('platform.login.submit')
            )}
          </button>
          <RouterLink to="/login" className="btn btn-light">
            {t('platform.login.tenantLogin')}
          </RouterLink>
        </form>
      </div>
    </div>
  );
}
